export default __webpack_public_path__ + "static/1.1_EN-4eabda08772f0fa9dee1a311d40b77d6.webp";